import React from 'react'
import { useTranslation } from 'react-i18next'

import type { ItemListSortSelectProps } from './type'

import { InputSelectSingle } from '@/components/ui'

import { options } from './const'

export const ItemListSortSelect = (props: ItemListSortSelectProps) => {
  const { t } = useTranslation()

  return (
    <InputSelectSingle<string>
      {...props}
      height="md"
      buttonLabel={t('item.list.sort.title')}
      options={options}
    />
  )
}
